import MainRoutes from './sources/MainRoutes';
function App() {
  
  return (
    <div className="App">
      <MainRoutes />
    </div>
  );
}

export default App;
